
import {Survey} from './survey';

export enum SurveyQuerySortField {
  Date = <any>'date',
  QScore = <any>'qscore',
  Stars = <any>'stars',
  Development = <any>'development'
}

export enum SurveyQuerySortDirection {
  Ascending = 1,
  Descending = -1
}

export enum SurveyQueryPage {
  First = 1,
  Previous,
  Next,
  Last
}

export class SurveyQuery {

  resultCount: number;
  totalCount: number;
  maxStars: number;

  firstPageLink: string;
  prevPageLink: string;
  nextPageLink: string;
  lastPageLink: string;

  resultLimit = 20;
  resultSkip: 0;

  // sortParam: SurveyQuerySortField = SurveyQuerySortField.Date;
  // sortDirection: SurveyQuerySortDirection = SurveyQuerySortDirection.Descending;
  // surveySortLabels = ['Newest', 'Oldest', 'Highest Rating', 'Lowest Rating', 'Community'];
  // selectedSortLabel = this.surveySortLabels[0];

  results: Survey[] = [];
  sortOptionsIndex = 0;

  sortOptions = [
    { label: 'Newest', field: SurveyQuerySortField.Date, direction: SurveyQuerySortDirection.Descending },
    { label: 'Oldest', field: SurveyQuerySortField.Date, direction: SurveyQuerySortDirection.Ascending },
    { label: 'Highest Rating', field: SurveyQuerySortField.Stars, direction: SurveyQuerySortDirection.Descending },
    { label: 'Lowest Rating', field: SurveyQuerySortField.Stars, direction: SurveyQuerySortDirection.Ascending },
    { label: 'Community', field: SurveyQuerySortField.Development, direction: SurveyQuerySortDirection.Ascending }
  ];

  // page state model paramete
  pageCount = 0;

  constructor() {}

  currentSortOption() {
    return this.sortOptions[this.sortOptionsIndex];
  }

  currentPageNumber() {
    return (this.resultSkip > 0) ? Math.ceil(this.resultSkip / this.resultLimit) + 1 : 1;
  }

  urlForPageType(pageType: SurveyQueryPage) {
    switch (pageType) {
      case SurveyQueryPage.First: {
        return this.firstPageLink;
      }

      case SurveyQueryPage.Previous: {
        return this.prevPageLink;
      }

      case SurveyQueryPage.Next: {
        return this.nextPageLink;
      }

      case SurveyQueryPage.Last: {
        return this.lastPageLink;
      }
    }
  }

  loadResults(data: any) {
    const json: JSON = data;

    if (json != null) {
      this.resultCount  = json['count_result'];
      this.totalCount   = json['count_total'];
      this.maxStars     = json['maxStars'];
      this.pageCount    = Math.ceil(this.resultCount / this.resultLimit);

      if (json['pagination'] ) {
        if (json['pagination']['href']) {
          this.firstPageLink = json['pagination']['href']['first'];
          this.prevPageLink = json['pagination']['href']['previous'];
          this.nextPageLink = json['pagination']['href']['next'];
          this.lastPageLink = json['pagination']['href']['last'];
        }
        if (json['pagination']['settings']) {
          this.resultLimit = json['pagination']['settings']['limit'];
          this.resultSkip = json['pagination']['settings']['skip'];
        }
      }

      if (json['surveys']) {
        this.results = [];
        for (const survey of json['surveys']) {
          this.results.push(new Survey(survey));
        }
      }
    }
  }
}


/*

 "results": {
 "count_result": 5,
 "count_total": 18,
 "pagination": {
 "href": {
 "first": "http://avid.api:5000/v1.0/reviews/acme-homes/surveys?skip=0&limit=5&sortfield=stars&sortdir=-1&devfilter=Eastonbury",
 "last": "http://avid.api:5000/v1.0/reviews/acme-homes/surveys?skip=13&limit=5&sortfield=stars&sortdir=-1&devfilter=Eastonbury",
 "next": "http://avid.api:5000/v1.0/reviews/acme-homes/surveys?skip=5&limit=5&sortfield=stars&sortdir=-1&devfilter=Eastonbury"
 },
 "settings": {
 "limit": 5,
 "skip": 0
 }
 },
 "surveys": [
 {
 "date": "November 2013",
 "development": "Eastonbury",
 "qscore": 5.9,
 "qtext": "Overall Rating",
 "seq": 30,
 "stars": 6.0,
 "public_comment": null
 },
 {
 "date": "January 2014",
 "development": "Eastonbury",
 "qscore": 5.9,
 "qtext": "Overall Rating",
 "seq": 27,
 "stars": 6.0,
 "public_comment": "Thank you for your feedback."
 },
 {
 "date": "October 2013",
 "development": "Eastonbury",
 "qscore": 5.8,
 "qtext": "Overall Rating",
 "seq": 33,
 "stars": 6.0,
 "public_comment": null
 },
 {
 "date": "April 2014",
 "development": "Eastonbury",
 "qscore": 5.9,
 "qtext": "Overall Rating",
 "seq": 21,
 "stars": 6.0,
 "public_comment": null
 },
 {
 "date": "June 2014",
 "development": "Eastonbury",
 "qscore": 5.4,
 "qtext": "Overall Rating",
 "seq": 17,
 "stars": 5.5,
 "public_comment": null
 }
 ]
 },
 */



// WEBPACK FOOTER //
// ./src/app/model/survey-query.ts